import React from "react";
import {useTranslation} from "react-i18next";
import {Skeleton} from "../../components/general/Skeleton";

interface Props {
    loading?: boolean;
    title?: string;
    className?: string;
    error?: Error | null;
    component?: React.ReactNode;
}

export default function NotPermissionComponent({loading, title, className, component, error}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    function RenderError(error: any | undefined | null) {
        if (error === undefined || error === null) {
            return false
        } else return error && error?.cause?.response?.status === 403;
    }

    return (
        <>
            {
                loading ?
                    <div className={`min-h-[200px] ${className}`}>
                        <Skeleton className={`min-h-[200px] ${className}`}/>
                    </div> :
                    RenderError(error) ?
                        <div className={`!border border-secondary rounded-[5px] p-2 text-center text-labelColor ${className}`}>
                            {`${t('not-permission-component')} ${title}`}
                        </div> :
                        <>
                            {component}
                        </>
            }
        </>
    )
}
